<template>
    <div class="page course-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div class="search">
            <van-search v-model="value" @click="$router.push({name:'search'})" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
        </div>

        <div class="tags">
            <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div class="swipe">
            <van-swipe :autoplay="3000" indicator-color="#fff">
                <van-swipe-item v-for="(item,i) in banners" :key="i">
                    <a :href="item.target_url.replace('https://dr-yyh.com','https://dr-yyh.com')">
                        <img :src="item.img" alt="">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>

        <div v-if="list && list.length > 0" class="course-list-section" style="margin-top: 22px">
            <van-row @click="go_detail(item)" v-for="item in list" :key="item.id">
                <div class="course-list-section-box">
                    <div class="course-list-section-left">
                        <van-image
                            fit="cover"
                            class="course-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="81"
                        />
                        <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/img/icon_list_tag_column.svg" alt="">
                    </div>
                    <div class="course-list-section-right">
                        <div class="course-list-section-right-title">{{item.title}}</div>
                        <div class="course-list-section-right-author" v-if="item.type != 2">{{item.doctor}} · {{item.hospital}}</div>
                        <div class="course-list-section-right-author" v-else>{{item.course_desc}}</div>
                        <div class="course-list-section-right-detail">{{item.view_count}}人学习</div>
                    </div>
                </div>
            </van-row>
        </div>
        <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
            <template slot="description">
                <div style="text-align: center">没有更多了</div>
                <div style="text-align: center">博医荟持续更新中…</div>
                <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    export default {
        name: 'course-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true
            }
        },
        methods: {
            onSearch(){
                this.fetch('course')
            },
            onCancel() {
                this.value = ""
                this.fetch("course")
            },
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get', Interface.banner, {type: 1}).then((res) => {
                        this.banners = res.data
                    })
                } else if (scene === 'category') {
                    Interface.getData('get', Interface.course.category).then((res) => {
                        this.categories = res.data
                        this.categories.unshift({name:"推荐",id:0})
                        if(this.categories.length < 5){
                            for(let i=999;i<= (1007 - this.categories.length);i++){
                                this.categories_child.push({name:"",id:i})
                            }
                        }
                        let search_channel = sessionStorage.getItem("course_search_channel")
                        if(this.$route.query.course_search_channel > 0){
                            this.category_index = parseInt(this.$route.query.course_search_channel)
                            this.changeCategory()
                        }else if (search_channel != null){
                            this.category_index = parseInt(search_channel)
                            this.changeCategory()
                        }
                    })
                } else if (scene === 'course') {
                    let params = {
                        category_id : this.category_id,
                        pageSize:999
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.course.list,params).then((res) => {
                        this.list = res.data.list
                        Interface.getShareInfo(this,"行业大咖精品课","","精品医学知识库，工作考试用得上")
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            changeCategory(){
                sessionStorage.setItem("course_search_channel",this.category_index)
                this.$router.push({
                    name : "course-list",
                    query: {
                        course_search_channel : this.category_index
                    }
                })
                this.category_id = this.categories[this.category_index].id
                this.fetch('course')
            },
            go_detail(item){
                if (item.type === 1){
                    this.$router.push({name:'course-detail',params: { id: item.id }})
                }else{
                    this.$router.push({'name':'course-column',params:{id:item.id}})
                }
            }
        },
        created() {
            this.fetch('banner')
            this.fetch('category')
            this.fetch('course')
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/course/list/index.vue